import { useEffect } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";
import { z } from "zod";
import { getAffirmativeOptions } from "../../../utils/data";

import Button from "../../themed/button";
import Select from "../../themed/select/select";

const pdoInclusionSchema = z.object({
    hasPDO: z.string().min(1, 'PDO inclusion is required'),
});

export type PDOInclusion = z.infer<typeof pdoInclusionSchema>;

type Props = {
    onSave: (info: PDOInclusion) => void;
    initialItem?: PDOInclusion;
};

const PDOInclusionForm: React.FC<Props> = ({ initialItem, onSave }) => {
    const form = useForm<PDOInclusion>({
        resolver: zodResolver(pdoInclusionSchema),
        mode: 'all',
        defaultValues: initialItem,
    });

    useEffect(() => {
        if (initialItem) form.reset(initialItem);
        else form.reset({ hasPDO: 'no' });
    }, [form, initialItem]);

    return (  
        <form onSubmit={form.handleSubmit(onSave)}>
            <div className="container">
                <div className="row">
                    <div className="col">
                        <Controller
                            control={form.control}
                            name="hasPDO"
                            render={({ field }) => (
                                <Select
                                    label="Has PDO"
                                    placeholder="Select Has PDO"
                                    options={getAffirmativeOptions()}
                                    value={field.value}
                                    onChange={field.onChange}
                                    name={field.name}
                                    error={form.formState.errors.hasPDO ? form.formState.errors.hasPDO.message : ''}
                                />
                            )}
                        />
                    </div>
                </div>
            </div>

            <div className="divider my-4"></div>

            <div className="d-flex justify-content-end">
                <Button
                    type="submit"
                    disabled={!form.formState.isValid}
                    label={form.formState.isSubmitting ? "Saving Information..." : "Save Information"}
                />
            </div>
        </form>
    );
};

export default PDOInclusionForm;